import { generateApiActionTypes } from 'utils/actions/generateActionTypes'
import { ENDPOINTS } from 'utils/api/callApi'
import { ICarrierCapacity } from 'apps/marketplace/store/contractLanes/types'
import { keymirror } from 'utils/keymirror'

export const CAPACITY_ACTION_TYPES = generateApiActionTypes('CAPACITY')
export const CAPACITY_UPDATE_ACTION_TYPES = generateApiActionTypes('CAPACITY_UPDATE')

export const getCapacity = (id: string) => {
  const requestData = {
    endpoint: ENDPOINTS.carriers,
    id,
    group: 'offer_limits',
  }
  return {
    type: '',
    payload: {
      callApi: true,
      requestData,
      actionTypes: Object.keys(CAPACITY_ACTION_TYPES),
    },
  }
}

export const CAPACITY_DIALOG = keymirror({
  CAPACITY_DIALOG_OPEN: undefined,
  CAPACITY_DIALOG_CLOSE: undefined,
})

export const openCarrierCapacityDialog = () => ({ type: CAPACITY_DIALOG.CAPACITY_DIALOG_OPEN })
export const closeCarrierCapacityDialog = () => ({ type: CAPACITY_DIALOG.CAPACITY_DIALOG_CLOSE })

export const editCarrierCapacity = (id: string, limits: ICarrierCapacity[]) => {
  const requestData = {
    endpoint: ENDPOINTS.carriers,
    id,
    method: 'PUT',
    group: 'offer_limits',
    body: {
      offerLimits: limits,
    },
  }
  return {
    payload: {
      callApi: true,
      requestData,
      actionTypes: Object.keys(CAPACITY_UPDATE_ACTION_TYPES),
    },
  }
}
